const name = '/usercenter/v1'
const urlName = `${name}/role`
const urlName2 = `${name}/permission`
const urlName3 = `${name}/user`

export default API => ({
  getUserMenu (item) {
    const { params, data } = item || {}
    return API({ url: `${urlName3}/getUserMenu`, params, data });
  },
  /**
   * 权限
   * @param { }  param0
   * 响应数据data：[1, 2]  1代表展示客户管理，2代表其它。
   */
  getFindRoleIds (item) {
    const { params, data } = item || {}
    return API({ url: `${urlName}/findRoleIds`, params, data });
  },
  /**
   * 获取角色
   * @param { }  param0
   * 响应数据 。
   */
  getFind (item) {
    const { params, data } = item || {}
    return API({ url: `${urlName}/find`, params, data });
  },
  getFindUserRole (item) {
    const { params, data } = item || {}
    return API({ url: `${urlName}/findUserRole`, params, data });
  },
  /**
   * 设置角色
   * @param { }  param0
   * 响应数据
   */
  postGrantRole (item) {
    const { params, data } = item || {}
    return API({ url: `${urlName}/grantRole`, method: 'post', params, data });
  },
  getFindByCondition (item) {
    const { params, data } = item || {}
    return API({ url: `${urlName}/findByCondition`, method: 'post', params, data });
  },
  getFindPermissionListByRoleId (item) {
    const { params, data } = item || {}
    return API({ url: `${urlName}/findPermissionListByRoleId`, params, data });
  },
  getFindPermissionMenuListByRoleId (item) {
    const { params, data } = item || {}
    return API({ url: `${urlName}/findPermissionMenuListByRoleId`, params, data });
  },
  postSave (item) {
    const { params, data } = item || {}
    return API({ url: `${urlName}/save`, method: 'post', params, data });
  },
  postDelete (item) {
    const { params, data } = item || {}
    return API({ url: `${urlName}/delete`, method: 'post', params, data });
  },

  getTree (item) {
    const { params, data } = item || {}
    return API({ url: `${urlName2}/getTree`, params, data });
  },
  postGrantPermission (item) {
    const { params, data } = item || {}
    return API({ url: `${urlName2}/grantPermission`, method: 'post', params, data });
  },
  postPermissionDelete (item) {
    const { params, data } = item || {}
    return API({ url: `${urlName2}/delete`, method: 'post', params, data });
  },
  postPermissionSave (item) {
    const { params, data } = item || {}
    return API({ url: `${urlName2}/save`, method: 'post', params, data });
  },
})